import React, { useMemo } from "react";
import {
  CardWrap,
  ContentPad,
  Row,
  TitleWrap,
  Dot,
  Title,
  ValueText,
  Unit,
  BarRow,
  BarTrack,
  BarFill,
} from "./styles";

const pct = (u, t) => (t > 0 ? Math.round((u / t) * 100) : 0);

type GaugeProps = {
  title: React.ReactNode;
  used: number;
  total: number;
  unit: string;
  color?: string;
  format?: () => string; // ✅ optional
};

const Gauge = ({
  title,
  used,
  total,
  unit,
  color = "#4f46e5",
  format,
}: GaugeProps) => {
  const p = pct(used, total);
  const text = useMemo(
    () => (format ? format() : `${used} / ${total}`),
    [used, total, format]
  );

  return (
    <CardWrap
      style={
        {
          ["--g-color" as any]: color,
        } as React.CSSProperties
      }
      tabIndex={0}
    >
      <ContentPad>
        <Row>
          <TitleWrap>
            <Dot aria-hidden />
            <Title title={title}>{title}</Title>
          </TitleWrap>

          <ValueText>
            {text}
            {unit && <Unit>&nbsp;{unit}</Unit>}
          </ValueText>
        </Row>
      </ContentPad>

      <BarRow>
        <BarTrack role="meter">
          <BarFill $color={color} $width={`${Math.max(0, Math.min(100, p))}`} />
        </BarTrack>
      </BarRow>
    </CardWrap>
  );
};

export default Gauge;
